import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SignalEntityQuery} from '../../state/signal-entity.store';
import {QuestionState, QuestionStore} from './question.store';
import {Question} from '../../models/underwriter.model';

@Injectable({
  providedIn: 'root'
})
export class QuestionQuery extends SignalEntityQuery<Question, QuestionState> {
  constructor(protected store: QuestionStore) {
    super(store);
  }

  getByParentControl(parent_id: any): Observable<any> {
    return this.selectAll({
      filterBy: [
        entity => entity.parent_control !== null && entity.parent_control === parent_id
      ]
    });
  }

  getByQuestionTypes(question_ids: number[]): Observable<any> {
    return this.selectAll({
       filterBy: [
           entity => entity.cent_aq_question_type_id !== null && question_ids.some((question_type: any) => question_type == entity.cent_aq_question_type_id)
       ]
    });
  }

  getById(id: any): Observable<any> {
    return this.selectAll({
      filterBy: [
        entity => entity.cent_aq_question_id === id
      ]
    });
  }
  getAllQuestions() {
    return this.getAll(); // This will return all questions in the store
  }
}
